module.exports = __webpack_public_path__ + "static/media/437GriffinStNW_2018-06-05_37.e2d42df9.jpg";